import $ from 'jquery';

import BrInputBox from '@components/BrInputBox';

export default function numberFilter() {
  return (
    <div className="number-filter">
      <div className="dropdown-holder">
        <select
          data-id="brtable-colsort-filter-number-dropdown"
          name="type"
          onChange={(e) => {
            $(e.target)
              .closest('.dropdown-holder')
              .siblings('.numeric-input-box:last')
              .toggleClass('hidden', $(e.target).val() !== 'bt');
          }}
        >
          <option value="gt">Greater than</option>
          <option value="gte">Greater than or equal to</option>
          <option value="lt">Less than</option>
          <option value="lte">Less than or equal to</option>
          <option value="eq">Is equal to</option>
          <option value="bt">Is between</option>
        </select>
      </div>
      <BrInputBox className="numeric-input-box" name="value1" />
      <BrInputBox className="numeric-input-box hidden" name="value2" />
    </div>
  );
  /*
  return (
    <div className="number-filter">
      <BrDropdownMenu
        items={[
          {title: 'Greater than', value: 'gt'},
          {title: 'Greater than or equal to', value: 'gte'},
          {title: 'Less than', value: 'lt'},
          {title: 'Less than or equal to', value: 'lte'},
          {title: 'Is equal to', value: 'eq'},
          {title: 'Is between', value: 'bt'},
        ]}
        onSelect={(value) => {
          // console.log(this);
          // console.log(value);
          // console.log($(this).closest('.dropdown-holder'));
        }} />
      <BrInputBox className='numeric-input-box' name='value1' />
      <BrInputBox className='numeric-input-box' name='value2' />
    </div>
  );
  */
}
